import { option, record } from 'fp-ts';
import { identity, pipe } from 'fp-ts/function';
/**
 * For the very specific use case of `obj != null && Object.keys(obj).length > 0`.
 * For convenience reasons, this currently also refines to NonNullable.
 */
export const isNonEmpty = (r) => {
    if (r != null)
        for (const key in r)
            if (Object.prototype.hasOwnProperty.call(r, key))
                return true;
    return false;
};
export const fromEntries = record.fromEntries;
export const fromRecord = option.fromPredicate(isNonEmpty);
export const toRecord = identity;
export const entries = Object.entries;
export const keys = Object.keys;
export const values = Object.values;
export const lookup = record.lookup;
/**
 * Like `lookup` but flipped, which the "V" suffix denotes.
 */
export const lookupV = (r) => (k) => pipe(r, lookup(k));
//# sourceMappingURL=nonEmptyRecord.js.map